import React, { useState } from "react";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // 清除该字段的错误信息
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // 验证邮箱格式
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // 验证所有字段并返回错误信息
  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.subject) {
      newErrors.subject = "Please select a subject";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 验证表单
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // 滚动到第一个错误字段
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    // 模拟表单提交
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setIsSubmitting(false);

      // 滚动到顶部显示成功消息
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      // 5秒后隐藏成功消息
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1000);
  };

  return (
    <div className="contact main">
      <div className="contact__container">
        {showSuccess && (
          <div className="contact__success">
            <div className="contact__success-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h2>Thank you!</h2>
            <p>Your message has been sent. We'll get back to you soon.</p>
          </div>
        )}

        <div className="contact__header">
          <h1>Contact Us</h1>
          <p>
            Have questions about our teas, coffees, or products? We'd love to
            hear from you!
          </p>
        </div>

        <div className="contact__content">
          <div className="contact__info">
            <div className="contact__info-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>Location</h3>
                <p>
                  13731 Omega Rd
                  <br />
                  Farmers Branch, TX 75244
                </p>
              </div>
            </div>

            <div className="contact__info-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h3>Email</h3>
                <p>steps@tugglefield.xyz</p>
              </div>
            </div>

            <div className="contact__info-item">
              <i className="fas fa-clock"></i>
              <div>
                <h3>Hours</h3>
                <p>
                  Monday - Friday: 10am - 6pm
                  <br />
                  Saturday: 10am - 5pm
                  <br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          <div className="contact__form">
            <form onSubmit={handleSubmit}>
              <div className="contact__form-row">
                <div className="contact__form-group">
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className={errors.firstName ? "contact__input--error" : ""}
                    placeholder="John"
                  />
                  {errors.firstName && (
                    <div className="contact__error">{errors.firstName}</div>
                  )}
                </div>

                <div className="contact__form-group">
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className={errors.lastName ? "contact__input--error" : ""}
                    placeholder="Doe"
                  />
                  {errors.lastName && (
                    <div className="contact__error">{errors.lastName}</div>
                  )}
                </div>
              </div>

              <div className="contact__form-row">
                <div className="contact__form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={errors.email ? "contact__input--error" : ""}
                    placeholder="john@example.com"
                  />
                  {errors.email && (
                    <div className="contact__error">{errors.email}</div>
                  )}
                </div>

                <div className="contact__form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="(555) 123-4567"
                  />
                </div>
              </div>

              <div className="contact__form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className={errors.subject ? "contact__input--error" : ""}
                >
                  <option value="">Please select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="order">Order Question</option>
                  <option value="wholesale">Wholesale Information</option>
                  <option value="tea">Tea Selection</option>
                  <option value="coffee">Coffee Selection</option>
                  <option value="other">Other</option>
                </select>
                {errors.subject && (
                  <div className="contact__error">{errors.subject}</div>
                )}
              </div>

              <div className="contact__form-group">
                <label htmlFor="message">Your Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className={errors.message ? "contact__input--error" : ""}
                  placeholder="How can we help you?"
                  rows="6"
                ></textarea>
                {errors.message && (
                  <div className="contact__error">{errors.message}</div>
                )}
              </div>

              <button
                type="submit"
                className="contact__submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span>
                    <i className="fas fa-spinner fa-spin"></i> Sending...
                  </span>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
